<template>
  <div style="padding-bottom: 2rem;">
    <div class="plus"><!-- img src='../assets/img/addDoc.png' @click="goYsg()" --></div>
    <div class='top'>检查记录</div>
    <div class='record'>
      <div class='record-item'>
        <div>姓名</div>
        <div>性别</div>
        <div>检查日期</div>
        <div>检查码</div>
        <div>档案</div>
      </div>
      <div v-for='(item, index) in recordList.list' :key='index' class='record-item'>
        <div>{{ item.studentName }}</div>
        <div>{{ item.sex }}</div>
        <div @click='showMask(item)'>{{ item.recordDate | formatDate }}</div>
        <div @click='goQr(item)'><i class="van-icon van-icon-qr ewm"></i></div>
        <div>
          <p @click='showMask(item)'>查看</p>
          <p v-if="item.childYesOfNo" @click="goChildPage(item)">0-6档案</p>
        </div>
      </div>
      <div class='tip'>
        <div class='tip-info'>注：点击检查日期查看当日检查结果</div>
        <!-- div class='tip-xieyi'><input type="checkbox" :checked="isCheck" @click="checkXieyi">我已阅读并同意 <span class="xieyi-href" @click="goXieyi">用户协议及隐私政策</span></div -->
      </div>
    </div>
    <div class="loading" v-if="showLoading"><van-loading type="spinner" />数据加载中...</div>
    <div v-if="showEwm" class="maskbox">
      <div class="mask" style="padding-bottom: 0.3rem;">
        <div class="maskclose" @click="showEwm = false">
          <img src="../assets/img/close.png" />
        </div>
        <div class="codetip">{{ studentName }}</div>
        <div id="qrCode" class="ewmcode" ref="qrCodeDiv"></div>
        <div class="codetip">
          <div>检查时，请出示此二维码。</div>
          <div style="text-align:left;">离院后如需咨询医生，请关闭此页，点击公众号左下角“在线咨询”，按提示选择医生咨询</div>
        </div>
      </div>
    </div>
    <div v-if="showXieyi" class="maskbox-one">
      <div class="mask">
        <div class='tip-one'>
          <div class="mask-title">用户协议及隐私政策</div>
          <div class="mask-content">为了更好的保障您的合法权益，请您阅读并同意以下协议</div>
          <div class="mask-xieyi">
            <span class="xieyi-href" @click="goXieyi">《用户协议及隐私政策》</span>
          </div>
          <div class="mask-btn-div">
            <div class="mask-btn" @click="cancelMask">不同意</div>
            <div class="mask-btn ok" @click="goOneDetail">同意</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  name: "record",
  data() {
    return {
      recordList: { list: '' },
      showEwm: false,
      studentName: '',
      isCheck: false,
      showLoading: 1,
      openId: '',
      studentIds: '',
      isOne: 0,
      showXieyi: false,
      nowItem: {},
    };
  },
  mounted() {
    let sid = this.$route.query.sid;
    let student_id = this.$route.query.student_id;
    this.studentIds = this.$route.query.studentIds;
    this.openId = this.$route.query.openId;
    if (student_id) {
      this.goSetPhone(student_id);
    }
    this.isOne = this.$route.query.isOne;
    // if (this.isOne) this.showXieyi = true;
    let _this = this;
    setTimeout(function () {
      _this.getRecord(sid);
      _this.getTitle();
    }, 500)
  },
  methods: {
    async goSetPhone(student_id) {
      let result2 = await this.$http.get(this.$url.checkPhone, {
        studentId: student_id
      });
      if (result2.result) {
        this.$router.push(`/setPhone?clazzName=${this.$route.query.cname}&tid=${this.$route.query.tid}&sid=${this.$route.query.sid}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&student_id=${this.$route.query.student_id}&studentIds=${this.$route.query.studentIds}`);
      }
    },

    /**
     * 获取记录
    */
    async getRecord(sid) {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.checkList, {
        openId: this.openId, studentId: sid,
        studentIds: this.studentIds,
        auth: auth.code,
        time: auth.time
      });
      let _this = this;
      if (result.message === 'Error: Miss auth parameter.') {
        setTimeout(function () {
          _this.showLoading = 0; _this.getRecord(sid);
        }, 500);
      } else {
        this.showLoading = 0;
        this.recordList.list = result.data.chekList;
        let list = result.data.chekList;
        if (list.length == 1) {
          let item = list[0]
          if (item.screenType == 0) {
            let hospitalId = item.hospitalId;
            if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
            let sid = item.uid;
            let activityId = item.activityId
            if (typeof (activityId) == "undefined") activityId = ''
            if (item.checkType === 1 && item.clazzId && activityId) {
              this.$http.post(this.$url.updateCheck, {
                auth: auth.code,
                time: auth.time,
                activityId: item.activityId,
                hospitalId: item.hospitalId,
                clazzId: item.clazzId,
                studentId: item.studentId,
              }, { headers: { "content-type": "application/json" } });
            }
            /* this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);*/
          }
        }
      }
    },
    goQr(item) {
      let _this = this;
      let sid = item.uid;
      this.showEwm = true;
      this.studentName = item.studentName;
      let url = item.codeUrl;
      setTimeout(function () {
        new QRCode(_this.$refs.qrCodeDiv, {
          text: url,
          width: 135,
          height: 135,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }, 500)

    },
    /**
     * 跳转详情页面
    */
    async goDetail(item) {
      let auth = this.$createAuth(this.$md5);
      let hospitalId = item.hospitalId;
      if (hospitalId == null || typeof (hospitalId) == undefined) hospitalId = '';
      let sid = item.uid;
      let activityId = item.activityId == null ? '' : item.activityId
      if (typeof (activityId) == "undefined") activityId = ''
      if (item.checkType === 1 && item.clazzId && activityId) {
        this.$http.post(this.$url.updateCheck, {
          auth: auth.code,
          time: auth.time,
          activityId: item.activityId,
          hospitalId: item.hospitalId,
          clazzId: item.clazzId,
          studentId: item.studentId,
        }, { headers: { "content-type": "application/json" } });
      }
      this.$router.push(`/detail?sid=${sid}&screenType=${item.screenType}&activityId=${activityId}&openId=${this.$route.query.openId}&hospitalId=${hospitalId}&tuid=${item.studentId}`);
    },
    checkXieyi() {
      this.isCheck = !this.isCheck;
    },
    checkXieyiOne() {
      this.$router.push(`/detail?sid=${this.$route.query.sid}&screenType=${this.$route.query.screenType}&activityId=${this.$route.query.activityId}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&tuid=${this.$route.query.tuid}`);
    },
    goXieyi() {
      this.$router.push(`/xieyi`);
    },
    goYsg() {
      this.$router.push(`/ysgInfo?cname=${this.$route.query.cname}&sid=${this.$route.query.tid}&openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}&type=1`);
    },
    async getTitle() {
      let openTitle = []
      let openTitleStr = localStorage.getItem("openTitle");
      let title = '';
      debugger
      if (openTitleStr && openTitleStr != 'null'){
        openTitle = JSON.parse(openTitleStr)
        openTitle.forEach((obj, index) => {
          // 在这里执行其他需要对每个对象执行的操作
          if (this.openId === obj.openId){
            title = obj.title;
          }
        });
        
        if (title) {
          document.title =  title
        }else {
          let auth = this.$createAuth(this.$md5);
          let result = await this.$http.get(this.$url.getTitle, {
            openId: this.openId,
            auth: auth.code,
            time: auth.time
          })
          if (result.message === 'Error: Miss auth parameter.') {
            this.getTitle();
          } else {
            title = result.data.title;
          }
          let objResult = {'openId': this.openId, 'title': title}
          openTitle.push(objResult)
          localStorage.setItem('openTitle', JSON.stringify(openTitle))
        }
      }else {
        let auth = this.$createAuth(this.$md5);
        let result = await this.$http.get(this.$url.getTitle, {
          openId: this.openId,
          auth: auth.code,
          time: auth.time
        })
        if (result.message === 'Error: Miss auth parameter.') {
          this.getTitle();
        } else {
          title = result.data.title;
        }
        let objResult = {'openId': this.openId, 'title': title}
        openTitle = []
        openTitle.push(objResult)
        localStorage.setItem('openTitle', JSON.stringify(openTitle))
      }
      document.title = title
    },
    cancelMask() {
      this.showXieyi = false;
    },
    showMask(item) {
      this.showXieyi = true;
      this.nowItem = item;
    },
    goOneDetail() {
      if (this.isOne) {
        this.checkXieyiOne();
      } else {
        this.goDetail(this.nowItem);
      }
    },
    goChildPage(item) {
      this.$router.push(`/child?openId=${this.$route.query.openId}&hospitalId=${item.hospitalId}&childId=${item.studentId}`);
    }
  },
  filters: {
    formatAge(value) {
      return value < 0 || value == "" ? 0 : value;
    },
    formatWeight(value) {
      return value == null ? '' : value + 'kg';
    },
    formatHeight(value) {
      return value == null ? '' : value + 'cm';
    },
    formatVal(value) {
      return value == null ? '' : value;
    },
    formatDate(value) {
      return value.length > 10 ? value.substring(0, 10) : value;
    }
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.record {
  width: 100%;

  .record-item {
    display: flex;

    div {
      line-height: 2.5em;
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #dddddd;

      &:nth-child(5n+1) {
        width: 1.5rem;
      }

      &:nth-child(5n+2) {
        width: 1rem;
      }

      &:nth-child(5n+3) {
        width: 2rem;
      }

      &:nth-child(5n+4) {
        width: 1.5rem;
      }

      &:nth-child(5n+5) {
        width: 1.5rem;
      }
    }

    &:nth-child(odd) {
      background: #eeeeee;
    }
  }
}

.tip {
  margin: 0.1rem 0.3rem;
  text-align: left;
  height: 0.6rem;
  line-height: 0.6rem;

  .tip-info {
    color: #999999;
    font-size: 0.26rem;
  }

  .tip-query {
    margin-top: 1rem;
    text-align: center;
  }

  .tip-xieyi {
    position: fixed;
    padding: 0.5rem 0;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    text-align: center;
    font-size: 0.28rem;
  }
}

.ewm {
  margin-top: 0.15rem;
  font-size: 18px;
}

.maskbox,
.maskbox-one {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 6rem;
    height: 6rem;
    margin: 30% auto;
    background: #fff;
    border-radius: 5px;
  }

  .maskclose {
    width: 100%;
    height: 0.5rem;

    img {
      width: 0.3rem;
      margin: 0.3rem;
      margin-left: 5.2rem;
    }
  }

  .codetip {
    width: 5rem;
    margin: 0 auto 0.3rem;
    line-height: 1.5em;
    font-size: 0.3rem;
  }
}

.mask-btn-div {
  display: flex;
  width: 5rem;
  justify-content: space-between;
  margin: 0.5rem auto;

  .mask-btn {
    width: 2rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border: 1px solid #ccc;
    border-radius: 5px;

    &.ok {
      color: #fff;
      border: 1px solid #5CC4AB;
      background: #5CC4AB;
    }
  }
}

.mask-title {
  margin-bottom: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
}

.mask-content {
  margin-bottom: 0.3rem;
  line-height: 0.5rem;
  text-align: left;
}

.maskbox-one {
  background: rgba(0, 0, 0, 0.8);

  .mask {
    width: 6.9rem;
    height: 5rem;
    padding: 0.3rem 0.5rem;
    box-sizing: border-box;
    margin-top: 30vh;
    border-radius: 10px;
    background: #fff;
  }

  .tip-xieyi-one {
    padding: 2rem 0;
    width: 100%;
    background: transparent;
    text-align: center;
    font-size: 0.32rem;
    color: #fff;
  }

  .xieyi-href {
    font-size: 0.3rem;
    color: #0a6aa1;
    font-weight: bold;
  }
}

.ewmcode {
  width: 150px;
  height: 150px;
  margin: 0 auto;
}

.xieyi-href {
  color: #0a6aa1;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}
</style>
